// 所有插件
import Vue from 'vue'
// 多语言
import VueI18n from 'vue-i18n'
// 动画插件css
import 'element-ui/lib/theme-chalk/base.css'
// 动画插件
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
// elementui插件
import { Pagination, Input, Image, Select, Option, DatePicker, Dialog } from 'element-ui'
// echarts图表插件
import * as echarts from 'echarts'

import locale from 'element-ui/lib/locale/index.js'
import lang from 'element-ui/lib/locale/lang/en.js'

const components = [Pagination, Input, Image, Select, Option, DatePicker, Dialog, CollapseTransition]

if (!Vue._use_plugins) {
  Vue._use_plugins = true
  Vue.use(VueI18n)
  const Element = {
    install (Vue) {
      components.forEach((item) => {
        Vue.component(item.name, item)
      })
    }
  }
  locale.use(lang)
  Vue.use(Element)
  Vue.prototype.$echarts = echarts // 将echarts注册为全局
}

export default ({ app, store }) => {
  app.i18n = new VueI18n({
    locale: store.state.locale,
    fallbackLocale: 'en',
    messages: {
      ar: require('~/static/languages/TXT_ar.json'),
      de: require('~/static/languages/TXT_de.json'),
      en: require('~/static/languages/TXT_en.json'),
      es: require('~/static/languages/TXT_es.json'),
      fil: require('~/static/languages/TXT_fil.json'),
      fr: require('~/static/languages/TXT_fr.json'),
      hi: require('~/static/languages/TXT_hi.json'),
      id: require('~/static/languages/TXT_id.json'),
      ja: require('~/static/languages/TXT_ja.json'),
      ko: require('~/static/languages/TXT_ko.json'),
      pt: require('~/static/languages/TXT_pt.json'),
      ru: require('~/static/languages/TXT_ru.json'),
      th: require('~/static/languages/TXT_th.json'),
      tr: require('~/static/languages/TXT_tr.json'),
      vi: require('~/static/languages/TXT_vi.json'),
      zh: require('~/static/languages/TXT_zh-HK.json'),
      ur: require('~/static/languages/TXT_ur.json'),
      'zh-cn': require('~/static/languages/TXT_zh-CN.json')
    }
  })
  app.i18n.path = (link) => {
    // 如果是默认语言，就省略
    if (app.i18n.locale === app.i18n.fallbackLocale) return `/${link}`
    return `/${app.i18n.locale}/${link}`
  }
}
